module.exports = __webpack_public_path__ + "assets/img/projects_item9.ca93463b.png";